import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import './index.css';
import App from './App';
import Landing from './site/Landing';
import Privacy from './site/Privacy';
import DeleteAccount from './site/DeleteAccount';
import ChildSafety from './site/ChildSafety';
import reportWebVitals from './reportWebVitals';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <BrowserRouter>
      <Routes>
        {/* Public marketing website (Play Store links) */}
        <Route path="/" element={<Landing />} />
        <Route path="/privacy" element={<Privacy />} />
        <Route path="/delete-account" element={<DeleteAccount />} />
        <Route path="/child-safety" element={<ChildSafety />} />
        {/* Admin panel */}
        <Route path="/admin" element={<App />} />
        <Route path="*" element={<Landing />} />
      </Routes>
    </BrowserRouter>
  </React.StrictMode>
);

reportWebVitals();
